// Controllo degli indirizzi email al momento della registrazione.
//
// Serve a intercettare gli errori di battitura nel dominio: "gnail.com" invece
// di "gmail.com" e' un indirizzo formalmente valido, quindi nessun controllo
// standard lo segnala, ma la password temporanea non arrivera' mai e la persona
// resta bloccata senza che nessuno se ne accorga.
//
// Al 10 settembre 2026 erano 9 clienti su 612 in questa condizione.

// I domini piu' usati dagli iscritti, ricavati dagli indirizzi gia' registrati.
const DOMINI_NOTI = [
    'gmail.com', 'icloud.com', 'hotmail.it', 'hotmail.com', 'hotmail.fr',
    'libero.it', 'yahoo.com', 'yahoo.it', 'outlook.it', 'outlook.com',
    'live.it', 'live.com', 'tiscali.it', 'virgilio.it', 'alice.it',
    'me.com', 'tim.it', 'email.it', 'fastwebnet.it', 'pec.it',
];

// Distanza di Levenshtein: quante correzioni servono per passare da a a b.
const distanza = (a, b) => {
    const matrice = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
    for (let j = 0; j <= b.length; j += 1) matrice[0][j] = j;

    for (let i = 1; i <= a.length; i += 1) {
        for (let j = 1; j <= b.length; j += 1) {
            matrice[i][j] = Math.min(
                matrice[i - 1][j] + 1,
                matrice[i][j - 1] + 1,
                matrice[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1),
            );
        }
    }

    return matrice[a.length][b.length];
};

export const normalizzaEmail = (valore) => String(valore || '').trim().toLowerCase();

// Restituisce l'indirizzo corretto se il dominio somiglia molto a uno noto,
// altrimenti null. Non blocca mai: i domini validi sono infiniti e un
// suggerimento sbagliato non deve impedire di registrarsi.
export const suggerisciCorrezione = (valore) => {
    const email = normalizzaEmail(valore);
    const [parteLocale, dominio] = email.split('@');

    if (!parteLocale || !dominio) return null;
    if (DOMINI_NOTI.includes(dominio)) return null;

    let migliore = null;

    for (const noto of DOMINI_NOTI) {
        const d = distanza(dominio, noto);
        if (d > 0 && d <= 2 && (!migliore || d < migliore.distanza)) {
            migliore = { dominio: noto, distanza: d };
        }
    }

    return migliore ? `${parteLocale}@${migliore.dominio}` : null;
};

// Errori che rendono l'indirizzo inutilizzabile, questi si bloccano.
export const erroreBloccante = (valore) => {
    const email = normalizzaEmail(valore);

    if (!email) return 'Inserisci un indirizzo email.';
    if ((email.match(/@/g) || []).length !== 1) return 'L\'indirizzo deve contenere una sola @.';

    const [parteLocale, dominio] = email.split('@');
    if (!parteLocale) return 'Manca la parte prima della @.';
    if (!dominio.includes('.')) return 'Il dominio non è valido: manca il punto (per esempio .com o .it).';
    if (/\s/.test(email)) return 'L\'indirizzo non può contenere spazi.';
    if (/\.\./.test(email) || dominio.startsWith('.') || dominio.endsWith('.')) return 'Il dominio non è scritto correttamente.';

    return null;
};
